/*
 *
 * QrCodePopup
 *
 * @version 1.0.0
 * @author Marco Civello
 * @since 16-Jun-2025
 */

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import QrCodePopup from './QrCodePopup'
import * as CreatePayByLinkPlusActions from 'Route/CreatePayByLinkPlus/modules/CreatePayByLinkPlusActions'
import { doPopup } from 'Store/actions/popup'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(CreatePayByLinkPlusActions, dispatch),
  closePopup: () => dispatch(doPopup('')),
  setQrCodeToastMessage: (data) => dispatch(CreatePayByLinkPlusActions.doSetQrCodeToastMessage(data))
})

const mapStateToProps = (state) => {
  const isPayToCard = state?.popup?.popupData?.isPayToCard
  const result = isPayToCard
    ? state?.PayToCard?.generatePayToCardResult || {}
    : state?.CreatePayByLinkPlus?.generatePayByLinkResult
      ? state?.CreatePayByLinkPlus?.generatePayByLinkResult
      : state?.pblManagement?.generatePBLSendLinkResult || {}

  return {
    id: result?.paymentLink?.linkId || '',
    isLoading: state?.loading.local_retrieveQrCode || false,
    qrCodeData: state?.CreatePayByLinkPlus?.generatePblQrcodeResult || null,
    subscriptions: state?.user?.getSubscriptionArray || [],
    generatePayByLinkResult: result
  }
}

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(QrCodePopup)
